import { action } from 'easy-peasy';

import { IActionSetMedicationsReport } from '../types';

const setMedicationsReport: IActionSetMedicationsReport = action((state, report) => {
  state.medications = report;
});

export default setMedicationsReport;
